<div class="spinner" *ngIf="show" style="margin-top:100px!important">
  <img src="../../../assets/spinner.gif" />
  <div class="counter">Loading {{ counter }} seconds</div>
</div>
